module.exports = __webpack_public_path__ + "assets/a-bitong1.e886bff0.svg";